import { render } from "./processFeature.vue?vue&type=template&id=536e2a13&scoped=true"
import script from "./processFeature.vue?vue&type=script&lang=js"
export * from "./processFeature.vue?vue&type=script&lang=js"

import "./processFeature.vue?vue&type=style&index=0&id=536e2a13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536e2a13"]])

export default __exports__